var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContainerPage",
    { attrs: { title: "Activar Integraciones" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "", color: "transparent" } },
        [
          _c("FilterActivarIntegracion", {
            on: {
              filter: function($event) {
                return _vm.filtrado($event)
              },
              clear: function($event) {
                _vm.isFiltred = false
              }
            }
          }),
          _c(
            "v-card-text",
            [
              _c("integration-table", {
                attrs: {
                  headers: _vm.selectedHeaders,
                  dataTable: _vm.dataTable,
                  totalItems: _vm.totalRegistros,
                  noDataMessage: _vm.noDataMessage
                },
                on: {
                  change: function($event) {
                    return _vm.onItemChange($event)
                  },
                  changeFlota: function($event) {
                    return _vm.onFlotaChange($event)
                  },
                  showAll: function($event) {
                    return _vm.showAll($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }